import _ from 'underscore';
import instrumentationSvc from '@bingads-webui-static-legacy/instrumentation/index';
import instrumentConsts from '@bingads-webui-static-legacy/instrumentation/constants';
import { AudienceAssociationView } from '@bingads-webui-campaign-legacy/audience-association/view/base-association-view';
import { AssociationTypes } from '@bingads-webui-campaign-legacy/audience-association/model/consts';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/audience/association');

export class BulkAssociationSectionView extends AudienceAssociationView {
  initialize(options) {
    super.initialize({
      scope: options.scope,
      refreshOnInitialize: true,
      fromBulkEdit: true,
      readOnlyMode: false,
      associationType: AssociationTypes.Bulk,
      entityLevel: options.entityLevel,
      isNewUI: options.isForVNext,
      deps: options,
      currentCampaign: options.currentCampaign,
      newI18n: options.newI18n,
    });

    this.currentCampaign = options.currentCampaign;
    this.entityLevel = options.entityLevel;

    this.bidMultiplier = 0;
  }

  render() {
    const associationInfoText = this.isNewAudienceEnabled ? i18n.get('AudiencesAssociation_BulkEditAssociationOnAudience_InfoText') : i18n.get('AudiencesAssociation_BulkEditAssociation_InfoText'),
      assoicationQueryLink = 'help:app51226',
      exclusionInfoText = this.isNewAudienceEnabled ? i18n.get('AudiencesAssociation_ListToAddgroup_ExclusionOnAudience_InfoText') : i18n.get('AudiencesAssociation_ListToAddgroup_Exclusion_InfoText'),
      exclusionQueryLink = 'help:app51226',
      associationInfoTextCampaign = this.isNewAudienceEnabled ?
        i18n.get('AudiencesAssociation_ListToCampaignOnAudience_InfoText') :
        i18n.get('AudiencesAssociation_ListToCampaign_InfoText');

    let bulkEditIntro = this.isNewAudienceEnabled ? i18n.getString('Audience_Adgroup_BulkEdit_Association_Exclusion_Audience_Intro') : i18n.getString('Audience_Adgroup_BulkEdit_Association_Exclusion_Intro');

    if (this.entityLevel === levelAtConstant.CAMPAIGN) {
      bulkEditIntro = this.isNewAudienceEnabled ? i18n.getString('Audience_Campaign_BulkEdit_Association_Exclusion_Audience_Intro') : i18n.getString('Audience_Campaign_BulkEdit_Association_Exclusion_Intro');
    }

    super.render({
      bulkEditIntro,
      associationInfoText,
      associationInfoTextCampaign,
      assoicationQueryLink,
      exclusionInfoText,
      exclusionQueryLink,
    });

    this.initCashbackPercentControlView(this.currentCampaign);

    return this;
  }

  getAction() {
    let bidType = this.doubleListBoxViewModel.selectedBidType();
    let { associationList, exclusionList } = this.getLists();
    let associationListIds = _.pluck(associationList, 'Id');
    let exclusionListIds = _.pluck(exclusionList, 'Id');


    const action = {
      Actions: [{
        '@odata.type': '#Model.AudienceAssociationAction',
        'Property': this.entityLevel === levelAtConstant.CAMPAIGN ? 'AudienceAssociation' : '',
        'BidType': bidType,
        'BidMultiplier': this.bidMultiplier,
        'AssociationList': associationListIds,
        'ExclusionList': exclusionListIds,
      }],
    };

    if (this.doubleListBoxViewModel.supportCashbackSettings()) {
      const cashbackPercent = this.cashbackPercentControlView.getCashbackPercentValue();

      action.Actions[0].CashbackAdjustment = cashbackPercent;
    }

    if (instrumentationSvc.logMessage) {
      if (this.isNewAudienceEnabled) {
        _.each(this.doubleListBoxViewModel.configSettings, (setting) => {
          instrumentationSvc.logMessage(
            [instrumentConsts.LOGCATEGORY.TRACE],
            instrumentConsts.LOGLEVEL.INFO,
            'SaveBulkEditTargetingExclusionByDmp/setAction',
            JSON.stringify({
              'DmpType': `${setting.type}`,
              'AssociationList': `${setting.targeting.selectedLists().length}`,
              'ExclusionList': `${setting.exclusion.selectedLists().length}`,
              'BidMultiplier': `${this.bidMultiplier}`,
            })
          );
        });
      } else {
        instrumentationSvc.logMessage(
          [instrumentConsts.LOGCATEGORY.TRACE],
          instrumentConsts.LOGLEVEL.INFO,
          'SaveBulkEditTargetingExclusion/setAction',
          JSON.stringify({
            'AssociationList': `${associationListIds.length}`,
            'ExclusionList': `${exclusionListIds.length}`,
            'BidMultiplier': `${this.bidMultiplier}`,
          })
        );
      }
    }

    return action;
  }

  clearAllErrors() {
    this.doubleListBoxViewModel.errors.clearAll();
  }

  addError(error) {
    this.doubleListBoxViewModel.errors.add([error]);
  }

  anyCriticalErrors() {
    let errors = this.doubleListBoxViewModel.errors();

    //check if there is any critical error, if yes, no go, if no let it go
    if (_.every(errors, (error) => {
      return error.property.isCritical === false;
    })) {
      return true;
    } else {
      return false;
    }
  }

  cleanup() {
    this.trigger('cleanup');
  }

  validateBidPercentage() {
    if (this.doubleListBoxViewModel.isBidPercentageValid()) {
      this.bidMultiplier = this.doubleListBoxViewModel.getBidPercentage();
      return true;
    } else {
      this.$el.find('#bidAdjustInput').focus();
      return false;
    }
  }

  validateCashbackPercent() {
    if (this.doubleListBoxViewModel.supportCashbackSettings()) {
      return this.cashbackPercentControlView.validate();
    }
    return true;
  }
}
